import { buildHttpHeaders } from "../../utils/buildHttpHeaders";

const PATH = 'notification'

export async function getNotificationsAsync(backendHeader: string, signal: AbortSignal) {
  const response = await fetch(`${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/${PATH}`,
    {
      method: 'GET',
      headers: buildHttpHeaders(backendHeader),
      signal: signal
    });

  if (response.status === 200 || response.status === 201) {
    const json = await response.text();
    const data = JSON.parse(json);
    return data;
  }

  throw new Error(await response.text());
}
export async function getConversationAsync(orderId: string, backendHeader: string, signal: AbortSignal) {
  const response = await fetch(`${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/${PATH}/getConversation/?orderId=${orderId}`,
    {
      method: 'GET',
      headers: buildHttpHeaders(backendHeader),
      signal: signal
    });

  if (!response.ok) {
    if (response.status === 404) {
      console.log("Conversation not found");
      return null;
    }

    throw new Error(await response.text());
  }

  const data = await response.json();
  return data;
}

export async function createConversationAsync(orderId: string, backendHeader: string, signal: AbortSignal) {
  const response = await fetch(`${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/${PATH}/createConversation/?orderId=${orderId}`,
    {
      method: 'POST',
      headers: buildHttpHeaders(backendHeader, 'application/json'),
      signal: signal,
    });

  if (!response.ok) {
    console.log("Conversation creation failed");
    return null;
  }

  const data = await response.json();
  return data;
}

export async function getAmountOfUnreadConversationsAsync(backendHeader: string, signal: AbortSignal) {
  const response = await fetch(`${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/${PATH}/amountofunreadconversations`,
    {
      method: 'GET',
      headers: buildHttpHeaders(backendHeader),
      signal: signal
    });

  if (response.status === 200 || response.status === 201) {
    const json = await response.text();
    const data = JSON.parse(json);
    return data;
  }

  throw new Error(await response.text());
}


export async function isConversationExistAsync(orderId: string, backendHeader: string, signal: AbortSignal) {
  const response = await fetch(`${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/${PATH}/isconversationexist/?orderId=${orderId}`,
    {
      method: 'GET',
      headers: buildHttpHeaders(backendHeader),
      signal: signal
    });

  if (!response.ok) {
    if (response.status === 404) {
      console.log("Conversation not exist");
      return null;
    }

    throw new Error(await response.text());
  }

  const data = await response.json();
  return data;
}

export async function addUserToConversationAsync(conversationId: string, backendHeader: string, signal: AbortSignal) {
  const response = await fetch(`${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/${PATH}/addusertoconversation/?conversationId=${conversationId}`,
    {
      method: 'POST',
      headers: buildHttpHeaders(backendHeader),
      signal: signal
    });

  if (!response.ok) {
    throw new Error(await response.text());
  }
}